export default __webpack_public_path__ + "static/media/banner-01.6c5fd801.png";